'use strict';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AdFoxFactory from '../AdFox/AdFoxFactory';

class AdFoxSplitter extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isLoaded: false,
      isError: false,
      stub: false
    };

    this.el = null;

    this.onRender = this.onRender.bind(this);
    this.onError = this.onError.bind(this);
    this.onStub = this.onStub.bind(this);
  }

  onRender () {
    this.setState({
      isLoaded: true
    });
  }

  onError () {
    this.setState({
      isError: true
    });
  }

  onStub () {
    this.setState({
      stub: true,
      isError: true
    });
  }

  componentDidMount () {
    if (!(window.Ya && window.Ya.adfoxCode)) {
      this.onError();
    }
  }

  render () {
    if (this.state.isError) {
      return null;
    }

    const {position, dealType, realtyType, regionName, index} = this.props;

    if (!this.el) {
      this.el = AdFoxFactory(regionName).getBySection(position, dealType, realtyType,
        {
          onRender: this.onRender,
          onError: this.onError,
          onStub: this.onStub,
          index: index || ''
        }
      );
    }

    return (
      <div className={'ad-fox-splitter ad-fox-splitter-' + position}>
        { !this.state.stub && this.el }
      </div>
    );
  }
}

AdFoxSplitter.propTypes = {
  regionName: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  index: PropTypes.number
};
AdFoxSplitter.defaultProps = {};

export default AdFoxSplitter;



// WEBPACK FOOTER //
// ./src/ui/Widgets/AdFoxSplitter.jsx